"use strict";

require("../../docs.css");
require("@ebay/skin/tokens");
require("@ebay/skin/global");
require("@ebay/skin/menu");
var _makeupMenu = _interopRequireDefault(require("makeup-menu"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// REQUIRE
// const Menu = require('makeup-menu').default;

// IMPORT

const log = e => console.log(e.type, e.detail);
window.onload = function () {
  document.querySelectorAll(".menu").forEach(function (el, i) {
    const widget = new _makeupMenu.default(el);
    el.addEventListener("makeup-menu-select", log);
    el.addEventListener("makeup-menu-change", log);
    el.addEventListener("makeup-menu-mutation", log);
  });
};